<template>
    <div> 
		<div class="page-btns-box" v-if="$utils.have('/h5/config/info')" >
		    <el-button type="primary" icon="el-icon-plus" @click="add" size="small">新增页面</el-button>
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column label="名称" min-width="200" show-overflow-tooltip>
					<template slot-scope="scope">
					    <el-link class="ellipsis" :href="scope.row.url" target="_blank">{{ scope.row.title }}</el-link>
					</template>				
				</el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/h5/config/info')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >SEO信息</el-button>
                        <el-button
                            v-if="$utils.have('/h5/resource/info')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="$router.push({path: `/operation/h5Page/resource/${scope.row.id}`})"
                            >页面元素</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
		<edit ref="dataEdit" @update="getDataList"></edit>
    </div>
</template>
<script>
import Edit from './components/edit'
export default {
	components:{Edit},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/h5/config/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },        
		//新增事件
		add(){
		    this.$refs.dataEdit.show();
		},
		//编辑事件
		edit(id) {
		    this.$refs.dataEdit.show(id);
		}
        
    },
};
</script>

<style lang="scss" scoped>
.ellipsis{
    max-width:100%;
}
</style>